export default "__VITE_ASSET__jIDc5WBC__"